module.exports = __webpack_public_path__ + "static/media/right-arrow.53b8b67b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/right-arrow.svg
// module id = 246
// module chunks = 0